import KunLoading28 from './src/index'

KunLoading28.install = function (Vue) {
	Vue.component(KunLoading28.name, KunLoading28);
}

export default KunLoading28;
